export const storageList = {
	layout: {
		title: "Lista de inventarios",
	},
	header: {
		searchPlaceHolder: "Buscar por inventario",
		importXML: "Importar XML",
		createStorage: "Crear Inventario",
	},
	indicators: {
		cost: {
			title: "Valor total en inventario",
			footer: {
				localStorage: "Inventario local",
				centralStorage: "Inventario Central",
			},
		},
		turnover: {
			high: "Mayor rotación",
			low: "Menor rotación",
		},
		zeroed: {
			title: "Productos agotados",
			seeMore: "Ver Más",
		},
		intervalNotice: "Valores referentes a los últimos 90 días",
		updatedAt: "Actualizado en {{date}}",
	},
	list: {
		local: "Local",
		central: "General",
		rename: "Renombrar inventario",
		delete: "Eliminar",
		valueInStorage: "Valor en inventario",
		productsInStorage: "Productos en inventario",
		productsInStorageCount: "{{count}} productos",
		createdAt: "Creado en {{date}}",
	},
	modalXml: {
		title: "Importar XML",
		warningMessage: {
			line1:
				"Seleccione el inventario de destino, descargue la hoja de cálculo ejemplo, llene e importe nuevamente.",
			line2:
				"¡Atención! El valor de los productos se informa en centavos. Ej: 123 equivale a {{currencySymbol}} 1,23",
		},
		form: {
			label: {
				storage: "Inventario",
				xml: "XML",
			},
			placeholder: {
				xml: "Elija un archivo .xml para importar",
			},
			validation: {
				missingField: "Campo obligatorio",
			},
		},
	},
	modalForm: {
		title: {
			createStorage: "Crear Inventario",
			editarStorage: "Editar Inventario",
		},
		form: {
			label: {
				name: "Nombre",
				isCentral: "Tipo de inventario",
			},
			options: {
				central: "Central",
				local: "Local",
			},
			placeholder: {
				name: "Nombre del inventario",
			},
			cancel: "Cancelar",
			submit: "Guardar",
		},
	},
	modalDelete: {
		title: "Eliminar Inventario",
		warningMessage: '¿Está seguro que desea eliminar el inventario "{{storageName}}" ?',
		submit: "Eliminar",
	},
};
